<template>
  <th :style="thStyleObj">
    <div class="th-box">
      <span class="th-text">{{thText}}</span>
    </div>
  </th>
</template>

<script>
  export default {
    props:['width', 'thText'],
    data(){
      return {
        thStyleObj: {
          width: this.width,
        }
      }
    },
  }
</script>

<style>

</style>